import { render, staticRenderFns } from "./food-table-make.vue?vue&type=template&id=26844d77&scoped=true&"
import script from "./food-table-make.vue?vue&type=script&lang=js&"
export * from "./food-table-make.vue?vue&type=script&lang=js&"
import style0 from "./food-table-make.vue?vue&type=style&index=0&id=26844d77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26844d77",
  null
  
)

export default component.exports